var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFunFacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E117F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-magnifying-glass",
    className: "st0",
    d: "M484.42,122.15c-200.62,0-363.25,162.63-363.25,363.25 s162.63,363.25,363.25,363.25c60.09,0.46,119.33-14.17,172.29-42.55c4.07,4.9,8.59,9.41,13.49,13.49L774,923.38 c38.94,43.61,105.86,47.39,149.47,8.45c43.61-38.94,47.39-105.86,8.45-149.47c-2.66-2.97-5.48-5.8-8.45-8.45L819.72,670.29 c-5.06-5.06-10.63-9.58-16.62-13.49c29.49-52.67,45.2-111.93,45.68-172.29c-0.24-200.52-162.73-363.01-363.25-363.25L484.42,122.15z  M484.42,225.95c142.63-0.7,258.82,114.36,259.51,256.99c0,0.82,0,1.64,0,2.46c0.65,66.05-23.84,129.87-68.49,178.53l-3.11,3.11 c-4.9,4.07-9.41,8.59-13.49,13.49c-48.31,42.84-110.85,66.15-175.42,65.38c-143.31,0-259.49-116.18-259.49-259.49 s116.18-259.49,259.49-259.49L484.42,225.95z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunFacts);
export default __webpack_public_path__ + "static/media/funFacts.1316f98e4d9b27e3995cca2ecc35454b.svg";
export { ForwardRef as ReactComponent };